class LoadingSpinnerController {
    constructor($window) {
        'ngInject';
        this.$window = $window;

        this.outerSize = 40;
        this.midSize = 0;
        this.innerSize = 0;
        this.outerStyle = {};
        this.midStyle = {};
        this.innerStyle = {};
    }

    $onInit() {
        if(this.size) {
            this.outerSize = this.size;
        }
        this.midSize = this.outerSize - 8;
        this.innerSize = this.outerSize - 16;

        this.outerStyle = {'height': this.outerSize + 'px', 'width': this.outerSize + 'px'};
        this.midStyle = {'height': this.midSize + 'px', 'width': this.midSize + 'px'};
        this.innerStyle = {'height': this.innerSize + 'px', 'width': this.innerSize + 'px'};
    }
}

export default LoadingSpinnerController;



// WEBPACK FOOTER //
// ./src/app/angular/loading-spinner/loading-spinner.controller.js